module.exports = __webpack_public_path__ + "img/userScale4.600a4c3e.png";